import { helpers } from '@vuelidate/validators'

import SwitchFieldPlugin from '@/features/settingsManagement/fieldManagement/edit/plugin/switchFieldPlugin/SwitchFieldPlugin.vue'
import SwitchFieldPluginValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/switchFieldPlugin/SwitchFieldPluginValueRenderer.vue'
import { normalizeFieldExtraData } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'
import { mergeDeep } from '@/features/utils/object.utils.js'

const defaultData = {
  trueValue: 1,
  falseValue: 0,
}

export const switchFieldPlugin = {
  type: 'switch',
  component: SwitchFieldPlugin,
  valueRenderer: SwitchFieldPluginValueRenderer,
  defaultExtraData: defaultData,
  getValidations({ props }) {
    const field = props.field
    const extraData = mergeDeep(defaultData, normalizeFieldExtraData(field.extraData))
    const rules = {}
    const key = field.key

    const isRequired =
      typeof props.externalRequired === 'boolean' ? props.externalRequired : field.isCompulsory
    if (isRequired) {
      const message = `${key} is required`
      rules.required = helpers.withMessage(message, value => {
        return value === extraData.trueValue
      })
    }

    return rules
  },
}
